import { Text } from '@wartek-id/text-v1'

import { assetUrl } from 'utils/url'

import type { FC } from 'react'

type DialogConsentReconfirmProps = {
  children?: React.ReactNode
}

export const DialogConsentReconfirm: FC<DialogConsentReconfirmProps> = ({
  children,
}) => {
  return (
    <div className="space-y-4">
      <img
        src={assetUrl('/illustrations/img-document-sync-data.png')}
        alt=""
        height={84}
        width={84}
      />

      <div className="space-y-1">
        <Text variant="display-sm">Konfirmasi ulang data atasan Anda?</Text>
        <Text variant="body-lg" color="subdued" className="!font-normal">
          Jika diulang, Anda mungkin tidak dapat melanjutkan Pengelolaan Kinerja
          dengan atasan Anda saat ini.
        </Text>
      </div>

      {children}
    </div>
  )
}
